import { useEffectEvent, useEffect } from "react";
import { usePreviewContext } from "../../../contexts/preview-context";
import { proxy } from "valtio";

export const clickToSwapState = proxy({
	isSwapModeActive: false,

	toggle() {
		clickToSwapState.isSwapModeActive = !clickToSwapState.isSwapModeActive;
	},
});
const isFillablePhotoZone = (
	zone: eXpress.core.IZone | undefined,
): zone is eXpress.core.PhotoZone => {
	return (
		!!zone &&
		eXpress.core.isPhotoZone(zone) &&
		zone.isZoneForPhotoSourceType("photo") &&
		zone.canChangeContent()
	);
};

function disableSwapMode(
	event: MouseEvent | KeyboardEvent,
	getZonesAtPoint: (
		point: { x: number; y: number },
		filter?: (zone: eXpress.core.IZone) => boolean,
	) => eXpress.core.IZone[] | undefined,
) {
	if (event instanceof KeyboardEvent) {
		clickToSwapState.isSwapModeActive = false;
		return;
	}

	if (event.target instanceof HTMLElement && event.target.closest(".photo-swap")) return;
	const clickedZones = getZonesAtPoint(
		{ x: event.clientX, y: event.clientY },
		isFillablePhotoZone,
	);

	if (clickedZones && clickedZones.length > 0) {
		return;
	}
	if (clickToSwapState.isSwapModeActive) {
		clickToSwapState.isSwapModeActive = false;
	}
}
export function useAutoStopSwapMode() {
	const { getZonesAtPoint } = usePreviewContext();

	const handleClick = useEffectEvent((e: MouseEvent) => disableSwapMode(e, getZonesAtPoint));
	const handleKey = useEffectEvent((e: KeyboardEvent) => disableSwapMode(e, getZonesAtPoint));
	useEffect(() => {
		document.addEventListener("click", handleClick, { capture: true });
		document.addEventListener("keydown", handleKey, { capture: true });

		return () => {
			document.removeEventListener("click", handleClick, { capture: true });
			document.removeEventListener("keydown", handleKey, { capture: true });
		};
	}, [getZonesAtPoint]);
}
